export class Role{
  constructor(
    public ID:number,
    private name:string,
    public warehouse:boolean,
    public contract:boolean,
    public service:boolean,
    public inventary:boolean,
    public customer:boolean

  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/role.model.ts